import React, { useState } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function FAQ() {
  const ref = useScrollAnimation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Qué formato tienen los recursos?',
    a: 'Todos los recursos están en formato PDF de alta calidad, listos para imprimir o usar directamente en pantalla desde tu celular, tablet o computadora.'
  }, {
    q: '¿Sirve para escuelas de Argentina?',
    a: 'Sí, todo el contenido está alineado al currículo argentino (NAP y diseños curriculares provinciales vigentes).'
  }, {
    q: '¿Puedo usar el material en talleres privados?',
    a: '¡Por supuesto! El material es súper versátil y es ideal tanto para escuelas formales como para talleres independientes o centros culturales.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de realizar el pago, recibís un correo electrónico con el enlace de acceso a todos los archivos para descargar o ver online.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí, tenés 7 días de garantía de satisfacción. Si sentís que el material no te sirve, nos escribís y te devolvemos el 100% del dinero sin hacer preguntas.'
  }];
  return <section id="faq" className="w-full bg-[#0d0d0d] py-24 px-4 border-t border-[#1a1a1a]" ref={ref} data-id="element-10">
      <div className="max-w-3xl mx-auto" data-id="element-11">
        <div className="scroll-hidden text-center mb-16" data-id="element-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{
          fontFamily: 'Georgia, serif'
        }} data-id="element-13">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-14">
          {faqs.map((faq, index) => <div key={index} className="scroll-hidden bg-[#141414] border border-[#2a2a2a] rounded-lg overflow-hidden" style={{
          transitionDelay: `${index * 50}ms`
        }} data-id="element-15">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-16">
                <span className="font-bold text-white text-lg pr-8" data-id="element-17">
                  {faq.q}
                </span>
                <span className="text-[#F5C518] text-2xl font-light" data-id="element-18">
                  {openIndex === index ? '−' : '+'}
                </span>
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-19">
                <p className="text-gray-400 leading-relaxed" data-id="element-20">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}